import { useQuery } from 'react-query';
import { getStaffsWorkingHours, getStaffDetail } from '../apis/new-staff.api';

export const useStaffDetailQuery = (id, options) => {
  return useQuery(['getStaffDetail', id], () => getStaffDetail({ id }), options);
};
export const useWorkingHoursQuery = (data, options) => {
  return useQuery(['getStaffsWorkingHours', data], () => getStaffsWorkingHours(data), options);
};
